export default "__VITE_ASSET__2cdae8ed__"